/**
 * Helper functions for managing auth tokens
 */

// Save token to both localStorage and sessionStorage
export const saveToken = (token: string) => {
  if (!token) {
    console.warn('Attempted to save empty token');
    return false;
  }

  try {
    localStorage.setItem('token', token);
    sessionStorage.setItem('token', token);
    return true;
  } catch (error) {
    console.error('Error saving token:', error);
    return false;
  }
};

// Get token from storage (tries localStorage first, then sessionStorage)
export const getToken = (): string | null => {
  try {
    const localToken = localStorage.getItem('token');
    if (localToken) {
      return localToken;
    }

    const sessionToken = sessionStorage.getItem('token');
    if (sessionToken) {
      // Save to localStorage for future use
      localStorage.setItem('token', sessionToken);
      return sessionToken;
    }

    console.warn('No token found in storage');
    return null;
  } catch (error) {
    console.error('Error getting token:', error);
    return null;
  }
};

// Remove token from all storage
export const removeToken = () => {
  try {
    localStorage.removeItem('token');
    sessionStorage.removeItem('token');
    console.log('Token removed from storage');
    return true;
  } catch (error) {
    console.error('Error removing token:', error);
    return false;
  }
};

// Check if token exists
export const hasToken = (): boolean => {
  return !!getToken();
}; 